// Types
import type { TAvatarProps, TAvatarSize } from './Avatar.type';

export const AVATAR_SIZES: TAvatarSize[] = [ 'sm', 'md', 'lg' ];
export const AVATAR_SIZE: { [key in TAvatarSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg'
}

export const AVATAR_DEFAULT_PROPS: TAvatarProps = {
	size: AVATAR_SIZE.md,
	alt: 'avatar-image',
}
